import { MutationTuple, useMutation } from '@apollo/client';
import { CREATE_COMMENT_ON_ASSIGNMENT_STEP } from 'graphql/steps/mutations/createCommentOnAssignmentStep.gql';
import {
  CreateCommentOnAssignmentStepMutation,
  CreateCommentOnAssignmentStepMutationVariables,
} from '__generated__/graphql';

export default function useMutationCreateCommentOnAssignmentStep(): MutationTuple<
  CreateCommentOnAssignmentStepMutation,
  CreateCommentOnAssignmentStepMutationVariables
> {
  return useMutation(CREATE_COMMENT_ON_ASSIGNMENT_STEP);
}
